export const loading = 'loading';
export const setAuthenticationState = 'setAuthenticationState';
export const setErrorMessage = 'setErrorMessage';
export const setUserState = 'setUserState';
